import React, { useEffect, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Container, Modal, Form, Button, Row, Col } from 'react-bootstrap';
import api from '../../../services/API';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import sortFunc from '../../../utils/ordernarColunaInt';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';

const ToSearch = (props) => {
  let input;
  const handleClick = () => {
    props.onSearch(input.value);
  };

  const handleEnterKey = (e) => {
    if (e.key === 'Enter') {
      props.onSearch(input.value);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center">
      <input
        className="input-theme busca mr-1"
        ref={(n) => (input = n)}
        type="text"
        onKeyUp={handleEnterKey}
      />
      <button
        className="btn-primario-slim"
        onClick={handleClick}
        style={{ width: 40, height: 40 }}
      >
        <i className="fa fa-search px-2"></i>
      </button>
    </div>
  );
};

export default function Regioes() {
  const [buscando, setBuscando] = useState(false);
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [showLocalizacoesModal, setShowLocalizacoesModal] = useState(false);
  const [localizacoesSelecionadas, setLocalizacoesSelecionadas] = useState([]);
  const [nomeRegiaoSelecionada, setNomeRegiaoSelecionada] = useState('');
  const [editando, setEditando] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [importando, setImportando] = useState(false);
  const [coordenadores, setCoordenadores] = useState([]);
  const [arquivoImport, setArquivoImport] = useState(null);
  const [formData, setFormData] = useState({
    id: null,
    nome: '',
    cidade: '',
    estado: '',
    coordenadorId: '',
  });

  const columns = [
    {
      dataField: 'nome',
      text: 'Nome',
      sort: true,
    },
    {
      dataField: 'coordenadorUsuario.nome',
      text: 'Coordenador',
      formatter: (cell, row) => {
        return row.coordenadorUsuario ? row.coordenadorUsuario.nome : '-';
      },
    },
    {
      dataField: 'localizacoes',
      text: 'Cidades/Estados',
      formatter: (cell, row) => {
        const total = row.localizacoes ? row.localizacoes.length : 0;
        return (
          <button
            className="btn-primario-slim"
            onClick={() => handleVerLocalizacoes(row)}
          >
            <i className="fa fa-map-marker-alt mr-2"></i>
            Ver Localizações ({total})
          </button>
        );
      },
    },
    {
      dataField: 'acoes',
      text: 'Ações',
      formatter: (cell, row) => {
        return (
          <button
            className="btn-primario-slim"
            onClick={() => handleEdit(row)}
          >
            <i className="fa fa-edit"></i>
          </button>
        );
      },
    },
  ];

  const defaultSorted = [
    {
      dataField: 'nome',
      order: 'asc',
      sort: true,
    },
  ];

  const options = {
    sizePerPage: 10,
    showTotal: true,
    sizePerPageList: [
      {
        text: '5',
        value: 5,
      },
      {
        text: '10',
        value: 10,
      },
      {
        text: '50',
        value: 50,
      },
      {
        text: '100',
        value: 100,
      },
      {
        text: 'Todos',
        value: data.length,
      },
    ],
    paginationTotalRenderer: (from, to, size) =>
      size > 0 ? (
        <span className="react-bootstrap-table-pagination-total px-2">
          {from}-{to} de {size} resultados
        </span>
      ) : (
        <span className="react-bootstrap-table-pagination-total px-2">
          Nenhum resultado
        </span>
      ),
  };

  useEffect(() => {
    buscarRegioes();
    buscarCoordenadores();
  }, []);

  const buscarRegioes = async () => {
    setBuscando(true);
    try {
      const resultado = await api.get('/api/regioes');
      if (resultado && resultado.data) {
        setData(resultado.data.regioes || []);
      }
    } catch (error) {
      toast.error('Erro ao buscar regiões', {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
    setBuscando(false);
  };

  const buscarCoordenadores = async () => {
    try {
      const resultado = await api.get('/api/usuarios');
      if (resultado && resultado.data) {
        // Filtrar apenas coordenadores (permissao = 3)
        const coordenadoresFiltrados = resultado.data.usuarios.filter(
          (usuario) => usuario.permissao === 3
        );
        setCoordenadores(coordenadoresFiltrados);
      }
    } catch (error) {
      console.error('Erro ao buscar coordenadores');
    }
  };

  const handleVerLocalizacoes = (regiao) => {
    setLocalizacoesSelecionadas(regiao.localizacoes || []);
    setNomeRegiaoSelecionada(regiao.nome);
    setShowLocalizacoesModal(true);
  };

  const handleEdit = (regiao) => {
    const primeiraLocalizacao = regiao.localizacoes && regiao.localizacoes.length > 0 
      ? regiao.localizacoes[0] 
      : { cidade: '', estado: '' };
    
    setFormData({
      id: regiao.id,
      nome: regiao.nome,
      cidade: primeiraLocalizacao.cidade,
      estado: primeiraLocalizacao.estado,
      coordenadorId: regiao.coordenador || '',
    });
    setEditando(true);
    setShowModal(true);
    buscarCoordenadores();
  };

  const handleNovo = () => {
    setFormData({
      id: null,
      nome: '',
      cidade: '',
      estado: '',
      coordenadorId: '',
    });
    setEditando(false);
    setShowModal(true);
    // Atualiza lista de coordenadores ao abrir modal
    buscarCoordenadores();
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setFormData({
      id: null,
      nome: '',
      cidade: '',
      estado: '',
      coordenadorId: '',
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEnviando(true);

    try {
      const payload = {
        nome: formData.nome,
        cidade: formData.cidade,
        estado: formData.estado,
        coordenadorId: formData.coordenadorId || null,
      };

      if (editando) {
        await api.put(`/api/regioes/${formData.id}`, payload);
        toast.success('Região atualizada com sucesso!', {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      } else {
        await api.post('/api/regioes', payload);
        toast.success('Região cadastrada com sucesso!', {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }

      handleCloseModal();
      buscarRegioes();
    } catch (error) {
      // Erro já tratado pelo interceptor
    }
    setEnviando(false);
  };

  const downloadModelo = () => {
    const modeloData = [
      {
        'NOME REGIÃO': 'REGIONAL NORTE',
        CIDADE: 'Manaus',
        ESTADO: 'AM',
        COORDENADOR: 'Alexandra',
      },
      {
        'NOME REGIÃO': 'REGIONAL NORDESTE',
        CIDADE: 'Salvador',
        ESTADO: 'BA',
        COORDENADOR: 'Fabiana',
      },
      {
        'NOME REGIÃO': 'REGIONAL SUL',
        CIDADE: 'Curitiba',
        ESTADO: 'PR',
        COORDENADOR: 'Bem Hur',
      },
    ];

    const ws = XLSX.utils.json_to_sheet(modeloData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Regiões');
    XLSX.writeFile(wb, 'modelo-regioes.xlsx');
    toast.success('Modelo baixado com sucesso!', {
      position: toast.POSITION.BOTTOM_CENTER,
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setArquivoImport(file);
    }
  };

  const handleImport = async () => {
    if (!arquivoImport) {
      toast.error('Selecione um arquivo para importar', {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    setImportando(true);

    try {
      const formData = new FormData();
      formData.append('arquivo', arquivoImport);

      const response = await api.post('/api/regioes/import', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response && response.data) {
        const { inseridos, atualizados, coordenadoresCriados } = response.data;

        let mensagem = `Importação concluída com sucesso!`;
        if (inseridos > 0 || atualizados > 0 || coordenadoresCriados > 0) {
          mensagem += ` ${inseridos + atualizados} regiões processadas`;
          if (coordenadoresCriados > 0) {
            mensagem += `, ${coordenadoresCriados} coordenadores criados`;
          }
        }

        toast.success(mensagem, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        setShowImportModal(false);
        setArquivoImport(null);
        buscarRegioes();
      }
    } catch (error) {
      // Erro já tratado pelo interceptor
    }
    setImportando(false);
  };

  const handleCloseImportModal = () => {
    setShowImportModal(false);
    setArquivoImport(null);
  };

  return (
    <Container fluid>
      <div className="d-flex justify-content-between align-items-center pt-3 pb-3">
        <h4 className="f-black mb-0">Regiões</h4>
        <div>
          <button
            className="btn-primario-slim mr-2"
            onClick={() => setShowImportModal(true)}
          >
            <i className="fa fa-file-import mr-2"></i>
            Importar
          </button>
          <button className="btn-primario-slim" onClick={handleNovo}>
            <i className="fa fa-plus mr-2"></i>
            Nova Região
          </button>
        </div>
      </div>
      <hr className="hr-loja mt-0 mb-4" />
      <div>
        <ToolkitProvider
          bootstrap4
          keyField="id"
          data={data}
          columns={columns}
          search
        >
          {(props) => (
            <div>
              <div className="d-flex flex-row-reverse mb-2">
                <ToSearch {...props.searchProps} />
              </div>
              <BootstrapTable
                noDataIndication={() =>
                  buscando ? (
                    <span>
                      Carregando
                      <i className="fas fa-circle-notch fa-spin ml-3"></i>
                    </span>
                  ) : (
                    <span>Sem resultados</span>
                  )
                }
                classes="table-dark text-center rounded"
                wrapperClasses="rounded"
                bordered={false}
                pagination={paginationFactory(options)}
                defaultSorted={defaultSorted}
                {...props.baseProps}
              />
            </div>
          )}
        </ToolkitProvider>
      </div>

      <Modal show={showModal} onHide={handleCloseModal} backdrop="static" keyboard={false} centered>
        <Modal.Header closeButton>
          <Modal.Title>{editando ? 'Editar Região' : 'Nova Região'}</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Nome da Região *</Form.Label>
              <Form.Control
                type="text"
                name="nome"
                value={formData.nome}
                onChange={handleInputChange}
                required
                placeholder="Ex: Região Sul"
              />
            </Form.Group>

            <Row>
              <Col md={8}>
                <Form.Group className="mb-3">
                  <Form.Label>Cidade *</Form.Label>
                  <Form.Control
                    type="text"
                    name="cidade"
                    value={formData.cidade}
                    onChange={handleInputChange}
                    required
                    placeholder="Ex: São Paulo"
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Estado *</Form.Label>
                  <Form.Control
                    type="text"
                    name="estado"
                    value={formData.estado}
                    onChange={handleInputChange}
                    required
                    maxLength={2}
                    placeholder="Ex: SP"
                    style={{ textTransform: 'uppercase' }}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group>
              <Form.Label>Coordenador</Form.Label>
              <Form.Control
                as="select"
                name="coordenadorId"
                value={formData.coordenadorId || ''}
                onChange={handleInputChange}
              >
                <option value="">Selecione um coordenador</option>
                {coordenadores.map((coord) => (
                  <option key={coord.id} value={coord.id}>
                    {coord.nome}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Cancelar
            </Button>
            <Button
              type="submit"
              variant="primary"
              disabled={enviando}
            >
              {enviando ? 'Salvando...' : 'Salvar'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal show={showLocalizacoesModal} onHide={() => setShowLocalizacoesModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="fa fa-map-marker-alt mr-2"></i>
            Localizações - {nomeRegiaoSelecionada}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {localizacoesSelecionadas.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-striped table-bordered">
                <thead className="thead-dark">
                  <tr>
                    <th>Cidade</th>
                    <th>Estado</th>
                  </tr>
                </thead>
                <tbody>
                  {localizacoesSelecionadas.map((loc, index) => (
                    <tr key={index}>
                      <td>{loc.cidade}</td>
                      <td>{loc.estado}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="alert alert-info">
              <i className="fa fa-info-circle mr-2"></i>
              Nenhuma localização cadastrada para esta região.
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowLocalizacoesModal(false)}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showImportModal} onHide={handleCloseImportModal} size="lg" backdrop="static" keyboard={false} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="fas fa-file-upload mr-2"></i>
            Importar Regiões
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="alert alert-info mb-4">
            <h6 className="alert-heading mb-3">
              <i className="fas fa-info-circle mr-2"></i>
              Como funciona
            </h6>
            <ol className="mb-0 pl-3">
              <li className="mb-2">Baixe o modelo XLSX clicando no botão abaixo</li>
              <li className="mb-2">Preencha as 4 colunas obrigatórias: <strong>NOME REGIÃO</strong>, <strong>CIDADE</strong>, <strong>ESTADO</strong> e <strong>COORDENADOR</strong></li>
              <li className="mb-2">Coordenadores inexistentes serão criados automaticamente</li>
              <li className="mb-0">Regiões existentes serão atualizadas</li>
            </ol>
          </div>

          <div className="text-center mb-4 p-4 border rounded bg-light">
            <i className="fas fa-download fa-2x text-success mb-3"></i>
            <div>
              <Button
                variant="success"
                size="lg"
                onClick={downloadModelo}
              >
                <i className="fas fa-download mr-2"></i>
                Baixar Modelo XLSX
              </Button>
            </div>
          </div>

          <div className="p-3 border rounded">
            <Form.Group className="mb-0">
              <Form.Label className="font-weight-bold">
                <i className="fas fa-file-excel text-success mr-2"></i>
                Selecione o arquivo preenchido
              </Form.Label>
              <Form.Control
                type="file"
                accept=".xlsx,.xls"
                onChange={handleFileChange}
                className="mt-2"
              />
              {arquivoImport && (
                <div className="alert alert-success mt-3 mb-0">
                  <i className="fas fa-check-circle mr-2"></i>
                  <strong>Arquivo selecionado:</strong> {arquivoImport.name}
                </div>
              )}
            </Form.Group>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseImportModal}>
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={handleImport}
            disabled={importando || !arquivoImport}
          >
            {importando ? (
              <>
                <i className="fas fa-spinner fa-spin mr-2"></i>
                Importando...
              </>
            ) : (
              <>
                <i className="fas fa-upload mr-2"></i>
                Importar Agora
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

